/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      first_name
      last_name
      email
      phone_number
      stripe_id
      subscription_id
      subscription_status
      user_group
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      first_name
      last_name
      email
      phone_number
      stripe_id
      subscription_id
      subscription_status
      user_group
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      first_name
      last_name
      email
      phone_number
      stripe_id
      subscription_id
      subscription_status
      user_group
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createResume = /* GraphQL */ `
  mutation CreateResume(
    $input: CreateResumeInput!
    $condition: ModelResumeConditionInput
  ) {
    createResume(input: $input, condition: $condition) {
      id
      applications_id
      application_details {
        name
        tags
      }
      contact_information {
        name
        email
        phone_number
        location
      }
      experiences {
        position
        company
        location
        start_date
        end_date
        description
      }
      education {
        school
        degree
        concentration_1
        concentration_2
        graduation_date
        GPA
      }
      skills {
        skills
      }
      projects {
        name
        link
        description
      }
      additional_links {
        name
        link
      }
      references {
        name
        relationship
        email
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateResume = /* GraphQL */ `
  mutation UpdateResume(
    $input: UpdateResumeInput!
    $condition: ModelResumeConditionInput
  ) {
    updateResume(input: $input, condition: $condition) {
      id
      applications_id
      application_details {
        name
        tags
      }
      contact_information {
        name
        email
        phone_number
        location
      }
      experiences {
        position
        company
        location
        start_date
        end_date
        description
      }
      education {
        school
        degree
        concentration_1
        concentration_2
        graduation_date
        GPA
      }
      skills {
        skills
      }
      projects {
        name
        link
        description
      }
      additional_links {
        name
        link
      }
      references {
        name
        relationship
        email
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteResume = /* GraphQL */ `
  mutation DeleteResume(
    $input: DeleteResumeInput!
    $condition: ModelResumeConditionInput
  ) {
    deleteResume(input: $input, condition: $condition) {
      id
      applications_id
      application_details {
        name
        tags
      }
      contact_information {
        name
        email
        phone_number
        location
      }
      experiences {
        position
        company
        location
        start_date
        end_date
        description
      }
      education {
        school
        degree
        concentration_1
        concentration_2
        graduation_date
        GPA
      }
      skills {
        skills
      }
      projects {
        name
        link
        description
      }
      additional_links {
        name
        link
      }
      references {
        name
        relationship
        email
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
